import { useEffect, useState } from 'react';
import { useTimeout } from 'usehooks-ts';

export default function useMinDurationLoadingState(
  isLoading: boolean,
  minimumLoadingDuration: number = 1000
) {
  const [minDurationIsLoading, setMinDurationIsLoading] = useState(false);
  useTimeout(
    () => setMinDurationIsLoading(false),
    minDurationIsLoading ? minimumLoadingDuration : null
  );
  // This effect is used to set the loading state to true if the loading state is true
  // and the minimum loading duration has not been reached yet
  useEffect(() => {
    if (isLoading) setMinDurationIsLoading(true);
  }, [isLoading]);

  return minDurationIsLoading || isLoading;
}
